import React from 'react';
import BaseIcon, { IconProps } from './Base.icon';

const ChevronRightIcon = ({ width, height }: IconProps) => {
  return (
    <BaseIcon width={width} height={height} viewBox="0 0 16 16">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.852 7.148L6.052 2.348C5.836 2.132 5.536 2 5.2 2C4.54 2 4 2.54 4 3.2C4 3.536 4.132 3.836 4.348 4.052L8.308 8L4.36 11.948C4.132 12.164 4 12.464 4 12.8C4 13.46 4.54 14 5.2 14C5.536 14 5.836 13.868 6.052 13.652L10.852 8.852C11.068 8.636 11.2 8.336 11.2 8C11.2 7.664 11.068 7.364 10.852 7.148Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
};

export default ChevronRightIcon;
